export default String.raw`
{% assign type = include -%}

<div {% unless type contains 'inv-add' and settings.buyerData == "yes" -%} class="form-js" novalidate {% endunless -%}>
    {% assign emailReadonly = false -%}
    {% assign emailRequired = false -%}
    {% assign euCountriesISOWithoutPL = "AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PT|RO|SK|SI|ES|SE" -%}
    {% assign countryChangeReload = false -%}
    {% assign countryVisible = true -%}
    {% assign nameVisible = true -%}
    {% assign addressDataVisible = true -%}

    {% if type contains 'customerAddress' -%}
        {% assign includeArray = type | Split: '|' -%}
        {% assign includeArraySize = includeArray | Size -%}
        {% if includeArraySize > 0 -%}
            {% assign includeIdArray = includeArray[0] | Split: '=' %}
            {% assign includeIdArraySize = includeIdArray | Size -%}
            {% if includeIdArraySize > 1 -%}
                {% assign addressId = includeIdArray[1] -%}
                <input type="hidden" name="addressId" value="{{ addressId }}">
            {% endif -%}
        {% endif -%}
        {% if includeArraySize > 1 -%}
            {% assign includeDefaultArray = includeArray[1] | Split: '=' -%}
            {% assign isDefault = includeDefaultArray[1] -%}
            {% if isDefault == 'true' -%}
                <input type="hidden" name="default" value="{{ isDefault }}">
            {% endif -%}
        {% endif -%}
    {% endif -%}

    {% if type contains 'inv-add' or page.QueryString contains 'invoice-address' -%}
        {% assign company = false -%}
        {% if page.QueryString contains 'invoice-address'-%}
            {% if page.QueryString contains 'company' -%}
                {% assign companyCheck = true -%}
            {% endif -%}
        {% else -%}
            {% if cart.Customer.Company -%}
                {% assign companyCheck = true -%}
            {% endif -%}
        {% endif -%}
        {% if companyCheck -%}
            {% assign company = true -%}
        {% endif -%}
        {% if usr.Authenticated == false and settings.defaultRegistration == 'company' -%}
            {% assign company = true -%}
            {% if page.Cookies.notAuthUserType == 'private' -%}
                    {% assign company = false -%}
            {% endif -%}
        {% endif -%}
        {% assign TINVisible = true -%}
        {% if cart.Customer.TIN != '' -%}
            {% assign tin = cart.Customer.TIN -%}
            {% assign vateu = cart.Customer.VATEU -%}
        {% else -%}
            {% assign tin = customer.TIN -%}
            {% assign vateu = customer.VATEU -%}
        {% endif -%}
        {% assign addressVisible = true -%}
        {% assign addressRequired = true -%}
        {% assign phoneVisible = false -%}
        {% assign phoneRequired = false -%}
        {% if cart == null -%}
            {% assign address = customer.Address -%}
        {% else -%}
            {% assign address = cart.Customer.InvoiceAddress -%}
        {% endif -%}
        {% assign invoiceDocument = false -%}
        {% if type contains 'inv-add=' -%}
            {% assign includeArr = type | Split: '|' -%}
            {% assign includeArrSize = includeArr | Size -%}
            {% assign countryInclude = includeArr[0] | Split: '=' -%}
            {% assign countryISOCode = countryInclude[1] -%}
            {% if includeArrSize > 1 -%}
                {% assign companyInclude = includeArr[1] | Split: '=' -%}
                {% assign companyIncludeValue = companyInclude[1] -%}
                {% if companyIncludeValue == 'true' -%}
                    {% assign company = true -%}
                {% else -%}
                    {% assign company = false -%}
                {% endif -%}
            {% endif -%}
            {% if includeArrSize > 2 -%}
                {% assign invoiceInclude = includeArr[2] | Split: '=' -%}
                {% assign invoiceIncludeValue = invoiceInclude[1] -%}
                {% if invoiceIncludeValue == 'true' -%}
                    {% assign invoiceDocument = true -%}
                {% endif -%}
            {% endif -%}
        {% else -%}
            {% if address.Country != '' -%}
                {% assign countryISOCode = address.Country -%}
            {% else -%}
                {% assign countryISOCode = config.DefaultCountry -%}
            {% endif -%}
            {% if cart.Customer.Invoice -%}
                {% assign invoiceDocument = true -%}
            {% endif -%}
        {% endif -%}
        {% assign dataContainer = '.invoice-address-container-js' -%}
        {% assign dataIncludeCountry = 'inv-add=' -%}
        {% assign dataIncludeCompany = 'inv-comp=' -%}
        {% assign dataIncludeInvoice = 'inv-inv=' -%}

        {% if company -%}
            {% assign invoiceDocument = true -%}
        {% endif -%}
        
        {% if usr.Authenticated == false -%}
            {% if countryISOCode == 'PL' -%}
                {% if settings.editDataFromGUS == 'no' and tin != '' -%}
                    {% assign readonly = true -%}
                {% endif -%}
            {% else -%}
                {% assign euCountriesISOWithoutPLArray = euCountriesISOWithoutPL | Split: '|' -%}
                {% for euCountryISO in euCountriesISOWithoutPLArray -%}
                    {% if countryISOCode == euCountryISO -%}
                        {% if settings.editDataFromVIES == 'no' -%}
                            {% assign readonly = true -%}
                        {% endif -%}
                        {% break -%}
                    {% endif -%}
                {% endfor -%}
            {% endif -%}
        {% endif -%}
        {% assign countryChangeReload = true -%}
        {% assign autoPost = true -%}
        {% if usr.Authenticated -%}
            {% assign emailReadonly = true -%}
        {% endif -%}

        {% assign cityRequired = config.Countries[countryISOCode].RequiredFields.City -%}
        {% assign streetRequired = config.Countries[countryISOCode].RequiredFields.Street -%}
        {% assign streetNoRequired = config.Countries[countryISOCode].RequiredFields.StreetNo -%}
        {% assign zipCodeRequired = config.Countries[countryISOCode].RequiredFields.ZipCode -%}
        {% assign TINRequired = config.Countries[countryISOCode].RequiredFields.TIN -%}

        {% if customer.Company or company -%}
            {% assign TINRequired = true -%}
        {% else -%}
            {% assign TINRequired = false -%}
        {% endif -%}

        {% unless invoiceDocument -%}
            {% assign countryVisible = false -%}
            {% assign nameVisible = false -%}
            {% assign addressDataVisible = false -%}
            {% assign TINRequired = false -%}
            {% assign recipeTinInfo = true -%}
        {% endunless -%}
    {% else -%}
        {% if type == 'orderDa' or type contains 'customerAddress' -%}
            {% if cart.Customer.Company -%}
                {% assign company = true -%}
                {% assign TINVisible = false -%}
            {% endif -%}
            {% assign addressVisible = true -%}
            {% assign addressRequired = true -%}
            {% assign phoneVisible = true -%}
            {% assign phoneRequired = cart.SelectedDelivery.PhoneRequired -%}
            {% if usr.Authenticated -%}
                {% assign emailReadonly = true -%}
            {% endif -%}
            {% if cart != '' -%}
                {% assign emailRequired = true -%}
                {% assign email = cart.Customer.Email -%}
                {% assign address = cart.Customer.DeliveryAddress -%}
            {% elseif customer.DeliveryAddress.Name != '' -%}
                {% assign address = customer.DeliveryAddress -%}
            {% else -%}
                {% assign address = customer.Address -%}
            {% endif -%}
            {% assign countryISOCode = cart.Customer.DeliveryAddress.Country -%}
            {% if type contains 'customerAddress' -%}
                {% for customerAddress in customer.DeliveryAddresses -%}
                    {% if customerAddress.Id == addressId -%}
                        {% assign address = customerAddress -%}
                        {% break -%}
                    {% else -%}
                        {% assign address = '' -%}
                    {% endif -%}
                {% endfor -%}
                {% assign phoneRequired = true -%}
                {% if address != '' -%}
                    {% assign countryISOCode = address.Country -%}
                {% endif -%}
            {% endif -%}
            {% if cart.SelectedDelivery.CollectionPointTypeId == 2 -%}
                {% assign showMapTrigger = true -%}
            {% endif -%}
        {% endif -%}
        
        {% assign cityRequired = config.Countries[countryISOCode].RequiredFields.City -%}
        {% assign streetRequired = config.Countries[countryISOCode].RequiredFields.Street -%}
        {% assign streetNoRequired = config.Countries[countryISOCode].RequiredFields.StreetNo -%}
        {% assign zipCodeRequired = config.Countries[countryISOCode].RequiredFields.ZipCode -%}
        {% assign TINRequired = config.Countries[countryISOCode].RequiredFields.TIN -%}

        {% if type == 'buyerAddress' -%}
            {% if cart.Customer.Company -%}
                {% assign company = true -%}
                {% assign TINVisible = false -%}
            {% endif -%}
            {% assign addressVisible = true -%}
            {% assign addressRequired = true -%}
            {% assign phoneVisible = true -%}
            {% assign phoneRequired = cart.SelectedDelivery.PhoneRequired -%}
            {% if usr.Authenticated -%}
                {% assign emailReadonly = true -%}
            {% endif -%}
            {% if cart != '' -%}
                {% assign email = cart.Customer.Email -%}
                {% assign address = cart.Customer.Buyer -%}
            {% elseif customer.DeliveryAddress.Name != '' -%}
                {% assign address = customer.DeliveryAddress -%}
            {% else -%}
                {% assign address = customer.Address -%}
            {% endif -%}
            {% assign countryISOCode = cart.Customer.DeliveryAddress.Country -%}
            {% if cart.SelectedDelivery.CollectionPointTypeId == 2 -%}
                {% assign showMapTrigger = true -%}
            {% endif -%}
            
            {% if cart.Customer.Buyer == null -%}
                {% assign company = false -%}
                {% assign TINVisible = false -%}
                {% assign addressVisible = false -%}
                {% assign addressRequired = false -%}
                {% assign phoneVisible = false -%}
                {% assign phoneRequired = false -%}
                {% assign countryVisible = false -%}
                {% assign nameVisible = false -%}
                {% assign addressDataVisible = false -%}
                {% assign TINRequired = false -%}
                {% assign recipeTinInfo = false -%}
            {% endif -%}
            {% assign readonly = false -%}
        
            {% if customer.Company or company -%}
                {% assign TINRequired = true -%}
            {% else -%}
                {% assign TINRequired = false -%}
            {% endif -%}

        {% endif -%}

    {% endif -%}

    {% if type == 'buyerAddress' -%}
        {% assign addressType = 1 -%}
 
    {% elseif type contains 'inv-add' or page.QueryString contains 'invoice-address' -%}
        {% assign addressType = 1 -%}
        {% if invoiceDocument -%}
            <input type="hidden" name="__action" value="Order/InvoiceAddressUpdate">
        {% else -%}
            <input type="hidden" name="__action" value="Order/TinUpdate">
        {% endif -%}
    {% elseif type contains 'customerAddress' -%}
        {% assign addressType = 2 -%}
        {% if addressId -%}
            <input type="hidden" name="__action" value="Customer/DeliveryAddressUpdate">
        {% else -%}
            <input type="hidden" name="__action" value="Customer/DeliveryAddressAdd">
        {% endif -%}
    {% else -%}
        {% assign addressType = 0 -%}
        <input type="hidden" name="__action" value="Order/DeliveryAddressUpdate">
    {% endif -%}

    {% if addressVisible -%}
        <div class="{% if company -%} company-form-js {% else -%} retail-form-js {% endif -%}">
            {% if type == 'buyerAddress'  -%}
                <input type="hidden" name="__action" value="Order/BuyerUpdate">
            {% endif -%}
            {% if type contains 'inv-add' or page.QueryString contains 'invoice-address' -%}
                <div class="cart-address-form__item">
                    <div class="cart-address-form__item-title">{{ translations.BuyingInShopAs }}</div>
                    <div class="cart-address-form__item-wrapper">
                        <label for="company" tabindex="0" role="radio" {% if usr.Authenticated -%} {% if company -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} {% else -%} {% if config.CompanyOnly or company -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} {% endif -%} class="cart-address-form__label">
                            <input id="company"
                                   class="cart__radio cart-invoice-radio-change-js" 
                                   type="radio" 
                                   name="company" 
                                   value="true" 
                                   {% if usr.Authenticated -%}
                                        {% if company -%}
                                            checked
                                        {% endif -%}
                                   {% else -%}
                                        {% if config.CompanyOnly or company -%}
                                            checked
                                        {% endif -%}
                                   {% endif -%}
                                   data-template="partials/cart/delivery-partials/address-form.html" 
                                   data-include="{{dataIncludeCountry}}{{ countryISOCode }}|{{dataIncludeCompany}}true|{{dataIncludeInvoice}}{{invoiceDocument}}"
                                   data-container="{{dataContainer}}"
                            >
                            <div class="cart__radio-box cart-address-form__radio"></div>
                            <span>{{ translations.Company }}</span>
                        </label>
                        {% if config.CompanyOnly == false -%}
                            <label for="company-only" tabindex="0" role="radio" {% unless company -%} aria-checked="true" {% else -%} aria-checked="false" {% endunless -%} class="cart-address-form__label">
                                <input id="company-only" 
                                       class="cart__radio cart-invoice-radio-change-js" 
                                       type="radio" 
                                       name="company" 
                                       value="false" 
                                       {% unless company -%}
                                            checked
                                       {% endunless -%}
                                       data-template="partials/cart/delivery-partials/address-form.html" 
                                       data-include="{{dataIncludeCountry}}{{ countryISOCode }}|{{dataIncludeCompany}}false|{{dataIncludeInvoice}}{{invoiceDocument}}"
                                       data-container="{{dataContainer}}"
                                >
                                <div class="cart__radio-box cart-address-form__radio"></div>
                                <span>{{ translations.PrivatePerson }}</span>
                            </label>
                        {% endif -%}
                    </div>
                </div>
                <div class="cart-address-form__item">
                    <div class="cart-address-form__item-title">{{ translations.SalesDocument }}</div>
                    <div class="cart-address-form__item-wrapper">
                        <label for="invoice" tabindex="0" role="radio" {% if invoiceDocument -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} class="cart-address-form__label">
                            <input id="invoice"
                                   class="cart__radio cart-invoice-radio-change-js"
                                   type="radio" 
                                   name="invoice" 
                                   value="true" 
                                   {% if invoiceDocument -%}
                                        checked
                                   {% endif -%}
                                   data-template="partials/cart/delivery-partials/address-form.html" 
                                   data-include="{{dataIncludeCountry}}{{ countryISOCode }}|{{dataIncludeCompany}}{{company}}|{{dataIncludeInvoice}}true"
                                   data-container="{{dataContainer}}"
                            >
                            {% if settings.recipeForCompanyInCart == "yes" -%}
                                <div class="cart__radio-box cart-address-form__radio"></div>
                            {% endif -%}
                            <span>{{ translations.Invoice }}</span>
                        </label>
                        {% if settings.recipeForCompanyInCart == "yes" and config.CompanyOnly == false and company == false -%}
                            <label for="invoice-recipe" tabindex="0" role="radio" {% if invoiceDocument == false  -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} class="cart-address-form__label">
                                <input id="invoice-recipe"
                                       class="cart__radio cart-invoice-radio-change-js" 
                                       type="radio" 
                                       name="invoice" 
                                       value="false" 
                                       {% if invoiceDocument == false  -%}
                                           checked
                                       {% endif -%}
                                       {% if config.CompanyOnly and cart.Customer.Company == false -%} disabled {% endif -%}
                                       data-template="partials/cart/delivery-partials/address-form.html" 
                                       data-include="{{dataIncludeCountry}}{{ countryISOCode }}|{{dataIncludeCompany}}{{company}}|{{dataIncludeInvoice}}false"
                                       data-container="{{dataContainer}}"
                                >
                                <div class="cart__radio-box cart-address-form__radio"></div>
                                <span>{{ translations.Recipe }}</span>
                            </label>
                        {% endif -%}
                    </div>
                </div>
            {% endif -%}
            {% unless type == 'buyerAddress' -%}
                <div class='form__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
            {% endunless -%}
            {% if emailRequired -%}
                <div class="form__input-wrapper">
                    <label for="email" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Email }}</label>
                    <input id="email" class="form__input-value input-value-js" type="email" name="email" value="{{email}}" autocomplete="email" maxlength="192" required {% if email != '' and emailReadonly -%} tabindex="-1" readonly {% endif -%}>
                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillEmail }}</div>
                    <div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
                </div>
            {% endif -%}
            {% if countryVisible -%}
                <div class="form__input-wrapper form__input-wrapper__country">
                    {% assign countriesSize = config.Countries | Size -%}
                    <span class="form__input-info input-info-js country {% if countriesSize == 1 -%} disabled {% endif -%}">{{ translations.Country }}</span>
                    {% if countriesSize > 1 -%}
                        <div class="cart__select select-wcag-js">
                            {% assign selectedCountry = "" -%}
                            {% for country in config.Countries -%}
                                {% if country.ISOCode == countryISOCode -%}
                                    {% assign selectedCountry = country -%}
                                    {% break -%}
                                {% endif -%} 
                            {% endfor -%}
                            <input type="hidden" 
                                name="countryCode" 
                                class="input-value-js cart-select-value-js {% if countryChangeReload -%} validate-after-replace-js {% endif -%}"
                                data-tin-regex="{{ selectedCountry.TINRegex }}" 
                                data-zip-regex="{{ selectedCountry.ZipCodeRegex }}" 
                                data-zip-format="{{ selectedCountry.ZipCodeFormat }}" 
                                {% if countryChangeReload -%}
                                    data-include="{{dataIncludeCountry}}{{ selectedCountry.ISOCode }}|{{dataIncludeCompany}}{{company}}|{{dataIncludeInvoice}}{{invoiceDocument}}"
                                    data-template="partials/cart/delivery-partials/address-form.html" 
                                    data-container="{{dataContainer}}" 
                                {% endif -%}
                                data-country="{{ selectedCountry.ISOCode }}"
                                value="{{ selectedCountry.ISOCode }}" 
                            >
                            <div tabindex="0" role="button" class="cart__select-value form__input-value cart-select-js">
                                <span class="cart-select-text-js">{{ config.Countries[selectedCountry.ISOCode].Name }}</span>
                                <div class="cart__select-arrow cart-select-arrow-js">
                                    <svg>
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                                    </svg>
                                </div>
                            </div>
                            <ul class="cart__select-list cart-select-list-js dropdown-js hidden-js">
                                {% for country in config.Countries -%}
                                    <li 
                                        tabindex="-1"
                                        class="cart__select-item"
                                        data-value="{{ country.ISOCode }}" 
                                        data-name="{{ config.Countries[country.ISOCode].Name }}"
                                        data-tin-regex="{{ country.TINRegex }}" 
                                        data-zip-regex="{{ country.ZipCodeRegex }}" 
                                        data-zip-format="{{ country.ZipCodeFormat }}" 
                                        {% if countryChangeReload -%}
                                            data-include="{{dataIncludeCountry}}{{ country.ISOCode }}|{{dataIncludeCompany}}{{company}}|{{dataIncludeInvoice}}{{invoiceDocument}}"
                                        {% endif -%} 
                                        >
                                            {{ config.Countries[country.ISOCode].Name }}
                                    </li>
                                {% endfor -%}
                            </ul>
                        </div>
                    {% else -%}
                        {% for country in config.Countries -%}
                            {% if country.ISOCode == countryISOCode -%}
                        <input class="form__input-value input-value-js" aria-label="{{ config.Countries[country.ISOCode].Name }}" type="text" value="{{ config.Countries[country.ISOCode].Name }}" disabled readonly>
                        <input class="form__input-value input-value-js" aria-label="{{ country.ISOCode }}" type="hidden" name="countryCode" value="{{ country.ISOCode }}" {% if addressRequired -%} required {% endif -%} data-tin-regex="{{ country.TINRegex }}" data-zip-regex="{{ country.ZipCodeRegex }}" data-zip-format="{{ country.ZipCodeFormat }}">
                            {% endif -%}
                        {% endfor -%}
                    {% endif -%}
                    {% if addressRequired -%}
                        <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillCountry }}</div>
                    {% endif -%}
                </div> 
            {% endif -%}
            {% if TINVisible -%}
                {% if recipeTinInfo -%}
                    <div class="cart-address-form__additional-text">{{translations.WantToGetRecipeInfo}}</div>
                {% endif -%}
                {% if config.ENTERPRISE and company -%}
                    {% for v in config.VATEU -%}
                        {% if v.ISOCode == countryISOCode -%}
                            {% assign vateuExists = true -%}
                            {% break -%}
                        {% endif -%}
                    {% endfor -%}
                    {% if vateuExists -%}
                        <div class="form__wrapper">
                            <div class="form__input-wrapper">
                                <span class="form__input-info input-info-js">{{ translations.CountryCode }}</span>
                                <div class="cart__select select-wcag-js">
                                    {% assign vateuToDisplay = "" %}
                                    {% for v in config.VATEU -%}
                                        {% if v.ISOCode == countryISOCode -%}
                                            {% assign vateuToDisplay = v.Value -%}
                                            {% break -%}
                                        {% else -%}
                                            {% assign vateuToDisplay = "" -%}
                                        {% endif -%}
                                    {% endfor -%}
                                    <input type="hidden" 
                                        name="vateu"
                                        class="input-value-js cart-select-value-js"
                                        value="{{ vateuToDisplay }}" 
                                    >
                                    <div role="button" tabindex="0" class="cart__select-value form__input-value cart-select-js">
                                        <span class="cart-select-text-js">{{ vateuToDisplay }}</span>
                                        <div class="cart__select-arrow cart-select-arrow-js">
                                            <svg>
                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <ul class="cart__select-list cart-select-list-js dropdown-js hidden-js">
                                        <li tabindex="-1" class="cart__select-item" data-value="" data-name=""></li>
                                        {% for v in config.VATEU -%}
                                            {% if v.ISOCode == countryISOCode -%}
                                                <li tabindex="-1" class="cart__select-item" data-value="{{ v.Value }}" data-name="{{ v.Name }}">{{ v.Name }}</li>
                                            {% endif -%}
                                        {% endfor -%}
                                    </ul>
                                </div>
                            </div>
                    {% endif -%}
                {% endif -%}
                            <div class="form__input-wrapper">
                                <label for="tin" class="form__input-info input-info-js tin-error-checker-no-required">{% if TINRequired -%}<span class="required">* </span>{% endif -%} {{ translations.TIN }}</label>
                                <input id ="tin" class="form__input-value input-value-js" type="text" name="tin" value="{{ tin }}" {% if TINRequired -%} required {% endif -%} data-check-sum="{% if countryISOCode == 'PL' -%}true{% else -%}false{% endif -%}" maxlength="20" data-edit-gus="{{settings.editDataFromGUS}}">
                {% if TINRequired -%}
                                <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillTIN }}</div>
                {% endif -%}
                                <div class="form__invalid-input validation-info-js validation-vies-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.NoTINinVIES }}</div>
                                <div class="form__invalid-input validation-info-js validation-vies-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorFillData }}</div>
                                <div class="form__invalid-input validation-info-js validation-vies-dont-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorTryLater }}</div>
                                <div class="form__invalid-input validation-info-js validation-tin-js hidden-js tin-validation-check-js">{{ translations.FillProperTIN }}</div>
                                <div class="form__invalid-input validation-info-js validation-gus-js hidden-js tin-validation-check-js">{{ translations.NoTINinGUS }}</div>
                                <div class="form__invalid-input validation-info-js validation-gus-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorFillData }}</div>
                                <div class="form__invalid-input validation-info-js validation-gus-dont-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorTryLater }}</div>
                            </div>
                {% if vateuExists -%}
                        </div>
                {% endif -%}
            {% endif -%}
            {% if nameVisible -%}
                {% if company -%}
                    <div class="form__input-wrapper">
                        <label for="company-name" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.CompanyName }}</label>
                        <input id="company-name" class="form__input-value input-value-js" aria-label="{{ translations.CompanyName }}" type="text" name="name" value="{{ address.Name | H }}" maxlength="50" required {% if readonly -%} readonly {% endif -%}>
                        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">
                            {{ translations.FillCompanyName }}
                        </div>
                    </div>
                    <div class="form__input-wrapper" name="name2">
                        <label for="company-name2" class="form__input-info input-info-js">{{ translations.CompanyName }}</label>
                        <input id="company-name2" class="form__input-value input-value-js" aria-label="{{ translations.CompanyName }}" type="text" name="name2" autocomplete="customer-name-2" value="{{ address.Name2 | H }}" maxlength="50" {% if readonly -%} readonly {% endif -%}>
                    </div>
                {% else -%}
                    <div class="form__input-wrapper">
                        <label for="name" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.NameAndSurname }} </label>
                        <input id="name" class="form__input-value input-value-js" aria-label="{{ translations.NameAndSurname }}" type="text" name="name" value="{{ address.Name | H }}" maxlength="50" required {% if readonly -%} readonly {% endif -%} >
                        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillNameAndSurname }}</div>
                    </div>
                    <div class="form__input-wrapper">
                        <label for="name2" class="form__input-info input-info-js">{{ translations.NameAndSurname }}</label>
                        <input id="name2" class="form__input-value input-value-js" aria-label="{{ translations.NameAndSurname }}" type="text" name="name2" autocomplete="customer-name-2" value="{{ address.Name2 | H }}" maxlength="50" {% if readonly -%} readonly {% endif -%} >
                    </div>
                {% endif -%}
            {% endif -%}
            {% if addressDataVisible -%}
                <div class="form__input-wrapper">
                    <label for="street" class="form__input-info input-info-js">{% if addressRequired and streetRequired -%}<span class="required">* </span>{% endif -%}{{ translations.Street }} </label>
                    <input id="street" class="form__input-value input-value-js" aria-label="{{translations.Street}}" type="text" name="street" value="{{ address.Street | H }}" maxlength="50" {% if addressRequired and streetRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
                    {% if addressRequired and streetRequired -%}
                        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillStreet }}</div>
                    {% endif -%}
                </div>
                <div class="form__wrapper">
                    <div class="form__input-wrapper">
                        <label for="streetNo" class="form__input-info input-info-js">{% if addressRequired and streetNoRequired -%}<span class="required">* </span>{% endif -%}{{ translations.HouseNumber }}</label>
                        <input id="streetNo" class="form__input-value input-value-js" aria-label="{{ translations.HouseNumber }}" type="text" name="streetNo" value="{{ address.StreetNo }}" maxlength="20" {% if addressRequired and streetNoRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
                        {% if addressRequired and streetNoRequired -%}
                            <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillHouseNumber }}</div>
                        {% endif -%}
                    </div>
                    <div class="form__input-wrapper">
                        <label for="unitNo" class="form__input-info input-info-js">{{ translations.FlatNumber }}</label>
                        <input id="unitNo" class="form__input-value input-value-js" aria-label="{{ translations.FlatNumber }}" type="text" name="unitNo" value="{{ address.UnitNo }}" maxlength="20" {% if readonly -%} readonly {% endif -%} >
                        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillFlatNumber }}</div>
                    </div>
                </div>
                <div class="form__wrapper first-short">
                    <div class="form__input-wrapper">
                        <label for="zipCode" class="form__input-info input-info-js">{% if addressRequired and zipCodeRequired -%}<span class="required">* </span>{% endif -%}{{ translations.ZipCode }}</label>
                        <input id="zipCode" class="form__input-value input-value-js" aria-label="{{ translations.ZipCode }}" {% if showMapTrigger -%} class="show-map-js" {% endif -%} type="text" name="zipCode" value="{{ address.ZipCode }}" {% if addressRequired and zipCodeRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} maxlength="20" >
                        {% if addressRequired and zipCodeRequired -%}
                            <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillZipCode }}</div>
                        {% endif -%}
                        <div class="form__invalid-input validation-zip-code-js hidden-js">{{ translations.FillProperZipCode }} <span class="zip-format-js"></span></div>
                    </div>
                    <div class="form__input-wrapper">
                        <label for="city" class="form__input-info input-info-js">{% if addressRequired and cityRequired -%}<span class="required">* </span>{% endif -%}{{ translations.City }} </label>
                        <input id="city" class="form__input-value input-value-js" aria-label="{{ translations.City }}" type="text" name="city" value="{{ address.City | H }}" maxlength="50" {% if addressRequired and cityRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
                        {% if addressRequired and cityRequired -%}
                            <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillCity }}</div>
                        {% endif -%}
                    </div>
                </div>
            {% endif -%}
            {% if phoneVisible -%}
                <div class="form__input-wrapper {% if company -%} company-form-js {% else -%} retail-form-js {% endif -%}">
                    <label for="phoneNo" class="form__input-info input-info-js">{% if phoneRequired -%}<span class="required">* </span>{% endif -%}{{ translations.PhoneNumber }}</label>
                    <input id="phoneNo" class="form__input-value input-value-js" aria-label="{{ translations.PhoneNumber }}" type="tel" inputmode="numeric" pattern="\d*" name="phoneNo" value="{{ address.PhoneNo }}" maxlength="20" data-error="{{ translations.FillPhoneNumber }}" {% if phoneRequired -%} required {% endif -%} >
                    {% if phoneRequired -%}
                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillPhoneNumber }}</div>
                    {% endif -%}
                </div>
            {% endif -%}
        </div>
    {% endif -%}

    {% unless settings.buyerData == "yes" and type contains 'inv-add' or page.QueryString contains 'invoice-address' -%}
        <div class="cart-address-form__btn-wrapper {% if type contains 'customerAddress' -%} customer-address-form {% endif -%}">
            {% if type contains 'customerAddress' -%}
                <button class="cart__action-btn cart-popup-closer-js">{{ translations.Cancel }}</button>
            {% endif -%}
            <button class="primary-action-button cart__save-btn cart-confirm-address-js" data-address-type="{{addressType}}" data-next-step="{{nextStep}}">
                {{translations.ButtonSave}}
            </button>
        </div>
    {% endunless -%}
</div>
`